<!-- 附件预览 -->
<template>
  <div class="AttachViewer">
    <el-dialog
      class="AttachViewer"
      :title="$t('attach.title')"
      :visible.sync="dialogTableVisible"
      width="480px"
      @closed="closed"
      append-to-body
      v-el-drag-dialog
      :close-on-press-escape="!imageViewerVisible && !pdfViewerVisible"
    >
      <el-form :disabled="false">
        <el-button
          @click="multiDownload"
          class="download-button"
          style="margin-bottom: 10px"
          >{{
            multiDownloadModel
              ? fileCount
                ? `${$t("attach.batchDownload")}(${fileCount})`
                : $t("buttons.cancel")
              : $t("attach.batchDownload")
          }}</el-button
        >
        <el-table
          ref="fileTable"
          :data="gridData"
          size="mini"
          border
          height="400"
          row-key="seq"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            v-if="multiDownloadModel"
            type="selection"
            width="40"
          >
          </el-table-column>
          <el-table-column
            type="index"
            :label="$t('table.SN')"
            class="sort"
            align="center"
            width="50"
          >
            <template slot-scope="scope">
              <span>{{ $set(scope.row, "seq", scope.$index + 1) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('table.name')"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.newFile">{{ scope.row.name }}</span>
              <el-link
                type="primary"
                v-else
                :underline="false"
                @click="handleAttach(scope.row)"
              >
                {{ scope.row.name }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.type')" width="80">
            <template slot-scope="scope">
              {{
                scope.row.name.split(".")[scope.row.name.split(".").length - 1]
              }}
            </template>
          </el-table-column>
          <el-table-column
            :width="previewType !== 'check' && !disabled ? 80 : 50"
            align="center"
          >
            <template slot="header" slot-scope="scope">
              <el-button
                type="text"
                size="large"
                icon="el-icon-circle-plus-outline"
                v-if="previewType !== 'check' && !disabled"
                @click="handleUpload"
              >
              </el-button>
              <span v-else>{{ $t("table.toolBar") }}</span>
            </template>
            <template slot-scope="scope">
              <el-button
                v-if="!scope.row.newFile"
                size="mini"
                icon="el-icon-download"
                type="text"
                :disabled="fileDownloading"
                @click="handleDownload(scope.row)"
              ></el-button>
              <el-button
                v-if="previewType !== 'check' && !disabled"
                size="mini"
                type="text"
                icon="el-icon-close"
                @click="handleDelete(scope.$index, scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <a ref="downloadObj"></a>
      </el-form>
    </el-dialog>
    <el-dialog
      id="file-previewer"
      key="file-previewer"
      ref="dialog__wrapper"
      append-to-body
      :title="$t('attach.preview')"
      :visible.sync="pdfViewerVisible"
      :close-on-click-modal="false"
      v-el-drag-dialog
      :modal="false"
      width="80%"
    >
      <iframe
        name="pdfViewer"
        ref="pdfViewer"
        :src="pdfPath"
        height="99%"
        width="100%"
      />
      <el-form :disabled="false">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="pdfViewerVisible = false">{{
            $t("buttons.close")
          }}</el-button>
        </span>
      </el-form>
      <div class="line" v-elDragWidth:false="$refs.dialog__wrapper"></div>
    </el-dialog>
    <viewer
      ref="imageViewer"
      v-if="imageViewerVisible"
      :options="options"
      style="height: 600px"
      @inited="inited"
    >
      <img :src="imagePath" style="display: none" />
    </viewer>
    <el-form :disabled="false">
      <attach-editor ref="AttachEditor" />
    </el-form>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
import largeFile from '@/views/Report/ReportEditor/js/largeFile.js'
import { fileInfo, downloadFile } from '@/api/largeFile.js'
import { component as Viewer } from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import AttachEditor from '@/components/AttachEditor'
import { mapGetters } from 'vuex'
import extendFunctions from '@/views/Report/ReportEditor/js/extend.js'
export default {
  name: 'AttachViewer',
  props: {
    previewType: {
      type: String,
      default: 'check'
    }
  },
  data() {
    return {
      pdfPath: '',
      pdfViewerVisible: false,
      loading: undefined,
      previewAttachInfo: {},
      dialogTableVisible: false,
      imageViewerVisible: false,
      fieldRange: undefined,
      options: {
        navbar: false,
        title: () => this.previewAttachInfo.name,
        toolbar: {
          zoomIn: true,
          zoomOut: true,
          oneToOne: true,
          reset: true,
          prev: false,
          play: {
            show: false
          },
          next: false,
          rotateLeft: true,
          rotateRight: true,
          flipHorizontal: true,
          flipVertical: true
        }
      },
      imagePath: '',
      gridData: [],
      disabled: false,
      multiDownloadModel: false,
      fileCount: 0,
      typeList: [
        { suffix: 'djvu', mime: 'image/vnd.djvu', type: 'text' },
        { suffix: 'doc', mime: 'application/msword', type: 'text' },
        { suffix: 'docm', mime: 'application/vnd.ms-word.document.macroenabled.12', type: 'text' },
        { suffix: 'docx', mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', type: 'text' },
        { suffix: 'dot', mime: 'application/msword', type: 'text' },
        { suffix: 'dotm', mime: 'application/vnd.ms-word.template.macroenabled.12', type: 'text' },
        { suffix: 'dotx', mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template', type: 'text' },
        { suffix: 'epub', mime: 'application/epub+zip', type: 'text' },
        { suffix: 'htm', mime: 'text/html', type: 'text' },
        { suffix: 'html', mime: 'text/html', type: 'text' },
        { suffix: 'odt', mime: 'application/vnd.oasis.opendocument.text', type: 'text' },
        { suffix: 'ott', mime: 'application/vnd.oasis.opendocument.text-template', type: 'text' },
        { suffix: 'pdf', mime: 'application/pdf', type: 'text' },
        { suffix: 'rtf', mime: 'application/rtf', type: 'text' },
        { suffix: 'txt', mime: 'text/plain', type: 'text' },
        { suffix: 'xps', mime: 'application/vnd.ms-xpsdocument', type: 'text' },
        { suffix: 'csv', mime: 'text/csv', type: 'spreadsheet' },
        { suffix: 'ods', mime: 'application/vnd.oasis.opendocument.spreadsheet', type: 'spreadsheet' },
        { suffix: 'ots', mime: 'application/vnd.oasis.opendocument.spreadsheet-template', type: 'spreadsheet' },
        { suffix: 'xls', mime: 'application/vnd.ms-excel', type: 'spreadsheet' },
        { suffix: 'xlsm', mime: 'application/vnd.ms-excel.sheet.macroenabled.12', type: 'spreadsheet' },
        { suffix: 'xlsx', mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', type: 'spreadsheet' },
        { suffix: 'xlt', mime: 'application/vnd.ms-excel', type: 'spreadsheet' },
        { suffix: 'xltm', mime: 'application/vnd.ms-excel.template.macroenabled.12', type: 'spreadsheet' },
        { suffix: 'xltx', mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template', type: 'spreadsheet' },
        { suffix: 'odp', mime: 'application/vnd.oasis.opendocument.presentation', type: 'presentation' },
        { suffix: 'otp', mime: 'application/vnd.oasis.opendocument.presentation-template', type: 'presentation' },
        { suffix: 'pot', mime: 'application/vnd.ms-powerpoint', type: 'presentation' },
        { suffix: 'potm', mime: 'application/vnd.ms-powerpoint.template.macroenabled.12', type: 'presentation' },
        { suffix: 'potx', mime: 'application/vnd.openxmlformats-officedocument.presentationml.template', type: 'presentation' },
        { suffix: 'pps', mime: 'application/vnd.ms-powerpoint', type: 'presentation' },
        { suffix: 'ppsm', mime: 'application/vnd.ms-powerpoint.slideshow.macroenabled.12', type: 'presentation' },
        { suffix: 'ppsx', mime: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow', type: 'presentation' },
        { suffix: 'ppt', mime: 'application/vnd.ms-powerpoint', type: 'presentation' },
        { suffix: 'pptm', mime: 'application/vnd.ms-powerpoint.presentation.macroenabled.12', type: 'presentation' },
        { suffix: 'pptx', mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', type: 'presentation' }
      ],
      templateId: undefined,
      recordId: undefined,
      fileDownloading: false
    }
  },
  components: {
    Viewer,
    AttachEditor
  },
  computed: {
    ...mapGetters(['onlyOfficeSetting'])
  },
  methods: {
    // 拖拽排序
    setSort() {
      const el = document.querySelectorAll('.AttachViewer .el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost', // Class name for the drop placeholder,
        setData: function (dataTransfer) {
          dataTransfer.setData('Text', '')
          // to avoid Firefox bug
          // Detail see : https://github.com/RubaXa/Sortable/issues/1012
        },
        onEnd: evt => {
          const targetRow = this.gridData.splice(evt.oldIndex, 1)[0]
          this.gridData.splice(evt.newIndex, 0, targetRow)
        }
      })
    },
    handleAttach(row) {
      this.loading = this.$loading({
        lock: true,
        text: this.$t('attach.prepare')
      })
      fileInfo(row.id).then(response => {
        this.previewAttachInfo = response.data
        var config = {
          onDownloadProgress: progressEvent => {
            var progressPersent = ((progressEvent.loaded * 0.75) / this.previewAttachInfo.size * 100 | 0)
            this.loading.text = progressPersent < 100 ? `${this.$t('attach.downloading')}(${progressPersent}%)...` : this.$t('attach.processing')
          }
        }
        var typeInfo = this.previewAttachInfo.fileType.split('/')
        var fileType = row.name.split('.')[row.name.split('.').length - 1]
        if (typeInfo[1] === 'pdf') {
          downloadFile(row.id, config).then(response => {
            var arr = response.data.split(',')
            var mime = arr[0].match(/:(.*?);/)[1]
            var bstr = atob(arr[1])
            var n = bstr.length
            var u8arr = new Uint8Array(n)
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n)
            }
            var fileBlob = new Blob([u8arr], { type: mime })
            this.pdfPath = './static/pdf/web/viewer.html?file=' + extendFunctions.getFileURL(fileBlob)
            this.pdfViewerVisible = true
            this.loading.close()
          }).catch(exception => {
            this.pdfPath = ''
          })
        } else if (typeInfo[0] === 'image') {
          downloadFile(row.id, config).then(response => {
            this.imagePath = response.data
            this.imageViewerVisible = true
            this.$nextTick(() => {
              this.viewer.show()
              this.loading.close()
            })
          }).catch(exception => {
            this.imagePath = ''
          })
        } else if (this.typeList.find(type => type.suffix === fileType)) {
          if (this.onlyOfficeSetting && this.onlyOfficeSetting.active) {
            this.$refs.AttachEditor.show(row.id, row.name, this.typeList.find(type => type.suffix === fileType), this.templateId, this.recordId)
          } else {
            this.$message({
              message: this.$t('attach.notSet')
            })
          }
        } else {
          this.$message({
            message: this.$t('attach.notSupport')
          })
        }
        this.loading.close()
      }).catch(exception => {
        this.loading.close()
      })
    },
    previewAttach(data, disabled, templateId, rid, fieldRange) {
      if (data.length === 0) return
      this.disabled = disabled
      this.dialogTableVisible = true
      this.gridData = data
      this.fieldRange = fieldRange
      this.templateId = templateId
      this.recordId = rid
      if (this.previewType !== 'check') {
        setTimeout(() => {
          this.setSort()
        }, 600)
      }
    },
    handleDownload(row) {
      this.fileDownloading = true
      this.$nextTick(async () => {
        largeFile.owner = this
        await largeFile.downloadAttach(row.id)
        this.fileDownloading = false
      })
    },
    handleDelete(index) {
      this.$confirm(this.$t('alert.delete'), this.$t('status.warning'), {
        confirmButtonText: this.$t('buttons.confirm'),
        cancelButtonText: this.$t('buttons.cancel'),
        type: 'warning'
      }).then(() => {
        this.gridData.splice(index, 1)
        this.$message({
          type: 'success',
          message: this.$t('alert.deleteSuccess')
        })
        // this.$emit('refreshView')
      }).catch(() => { })
    },
    handleUpload() {
      this.$emit('supplyAttachFile', this.gridData)
    },
    closed() {
      this.$emit('closed')
      this.$emit('refreshView', this.fieldRange, 2)
    },
    inited(viewer) {
      this.viewer = viewer
      var that = this
      this.viewer.hidden = event => {
        that.imageViewerVisible = false
      }
    },
    multiDownload() {
      var selection = this.$refs.fileTable.selection
      console.log(selection)
      if (this.multiDownloadModel) {
        if (selection.length) {
          // 开始下载
          var fileList = []
          selection.forEach(file => {
            fileList.push(file.id)
          })
          largeFile.owner = this
          largeFile.downloadFiles(fileList)
        } else {
          this.multiDownloadModel = false
        }
      } else {
        this.multiDownloadModel = true
      }
    },
    handleSelectionChange(row) {
      // 更新数量
      console.log(row)
      this.fileCount = row.length
    }
  }
}
</script>
<style lang="scss">
#file-previewer {
  .el-dialog__body {
    height: calc(100vh - 45px - 62px);
  }
  .line {
    position: absolute;
    right: 0px;
    bottom: 0px;
    cursor: se-resize;
    width: 0px;
    height: 0px;
    border-color: #e8eaec transparent;
    border-width: 0 0 15px 15px;
    border-style: solid;
    z-index: 999;
  }
}
a.el-link {
  display: block !important;
}
.viewer-container {
  z-index: 9999 !important;
}
.AttachViewer .el-dialog__body {
  margin-top: -10px;
}
/* .download-button{
    margin-top: 0px;
    margin-bottom: 10px;
  } */
</style>